// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__eOicP","Logo":"Auth_Logo__5x82h","Title":"Auth_Title__2flEN","Error":"Auth_Error__+gqA4"};